/**
 * @generated SignedSource<<ea8418b47dcb2c2b5c5a73414eb762af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type aiConsultDetailUpdateStatusMutation$variables = {
  linkparameter: string;
  status: number;
};
export type aiConsultDetailUpdateStatusMutation$data = {
  readonly update_request_ai_consult_detail: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type aiConsultDetailUpdateStatusMutation = {
  response: aiConsultDetailUpdateStatusMutation$data;
  variables: aiConsultDetailUpdateStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "linkparameter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "linkparameter"
              }
            ],
            "kind": "ObjectValue",
            "name": "linkparameter"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "request_ai_consult_detail_mutation_response",
    "kind": "LinkedField",
    "name": "update_request_ai_consult_detail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affected_rows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiConsultDetailUpdateStatusMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aiConsultDetailUpdateStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7aedb01499fe79cce1ad6feb6aafb9e0",
    "id": null,
    "metadata": {},
    "name": "aiConsultDetailUpdateStatusMutation",
    "operationKind": "mutation",
    "text": "mutation aiConsultDetailUpdateStatusMutation(\n  $linkparameter: String!\n  $status: Int!\n) {\n  update_request_ai_consult_detail(where: {linkparameter: {_eq: $linkparameter}}, _set: {status: $status}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "d302839f0c270cb12faba56746d58a98";

export default node;
